module.exports = __webpack_public_path__ + "img/photo.c4bb3fc9.svg";